module.exports = __webpack_public_path__ + "img/set-estimated.b3dcc6b6.svg";